import React from 'react';
import { Helmet } from 'react-helmet';

const GA_MEASUREMENT_ID = 'G-XQZC0K6Y71';

const GoogleAnalytics = () => {
  return (
    <Helmet>
      <script
        async
        src={`https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`}
      />
      <script>
        {`
          window.dataLayer = window.dataLayer || [];

          function gtag() {
            dataLayer.push(arguments);
          }

          gtag('js', new Date());
          gtag('config', '${GA_MEASUREMENT_ID}');
        `}
      </script>
      <script
        async
        src={`https://www.googletagmanager.com/gtag/js?id=G-TBQG17PB77`}
      />
      <script>
        {`
          window.dataLayer = window.dataLayer || [];

          function gtag() {
            dataLayer.push(arguments);
          }

          gtag('js', new Date());
          gtag('config', 'G-TBQG17PB77');
        `}
      </script>
    </Helmet>
  );
};

export default GoogleAnalytics;
